import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store/index';
import { updateFilterAttributeOptionAction } from '../slice';
import { FilterAttributeGroup } from '../types';

const updateFilterAttributeOptionOperation =
  (group: FilterAttributeGroup, typeName: string, value: string) =>
  (dispatch: ThunkDispatch<Store, undefined, AnyAction>) => {
    dispatch(
      updateFilterAttributeOptionAction({
        typeName,
        value,
        group,
      }),
    );
  };

export default updateFilterAttributeOptionOperation;
